<template>
    <div class="mx-auto w-full max-w-[1168px] pb-40 px-8 pt-0">
        <template v-if="state==='loaded'">
            <ui-header :title="'Request for Materials #'+requestForMaterials.reference"
                       :subtitle="requestForMaterials.id"
                       class="sticky sticky-top top-0 pt-6 pb-4 bg-white z-30">
            </ui-header>
            <div class="grid gap-6 grid-cols-12 pb-6 pt-0">
                <ui-data-grid-item class="xl:col-span-12" label="Package"
                                   :value="requestForMaterials.packageName"></ui-data-grid-item>
                <ui-date-picker label="Requested date:" name="dateTime"
                                v-model="requestForMaterials.requestedFor"
                                class="xl:col-span-12"
                                :disabled="true"
                                placeholder="What is the date for the requested materials?"
                                :with-time="false"
                ></ui-date-picker>
                <ui-textarea label="Notes" name="notes" :readonly="true" :disabled="true"
                             v-model="requestForMaterials.notes"
                             placeholder="Notes for this Request for Materials..."
                             class="xl:col-span-12"></ui-textarea>
            </div>
            <div class="mt-6">
                <h2 class="text-md font-semibold text-gray-700 mb-2">Materials Required</h2>
                <div
                    class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                    <div class="border-l border-gray-200 px-2 py-1 -mx-px flex-grow">Material</div>
                    <div class="border-l border-gray-200 px-2 py-1 -ml-px w-16 flex">UoM</div>
                    <div class="border-l border-gray-200 px-2 py-1 -ml-px flex"
                         :class="['Complete','In Progress','Acknowledged'].includes(requestForMaterials.status)?'w-32':'w-16'">
                        Qty
                    </div>
                    <div class="border-l border-gray-200 px-2 py-1 -ml-px w-1/3 flex">Resource Planning Report Item</div>
                    <div class="border-l border-gray-200 px-2 py-1 -ml-px w-16 flex"
                         v-if="['Complete','In Progress','Acknowledged'].includes(requestForMaterials.status)">Status
                    </div>
                </div>
                <request-for-material-item v-for="(item,key) in requestForMaterials.items" :key="key"
                                           :item="item" :request-for-materials="requestForMaterials"
                                           :readonly="true"
                ></request-for-material-item>
                <ui-data-grid class="mt-8"
                              v-if="['Acknowledged','Complete','In Progress'].includes(requestForMaterials.status)">
                    <ui-data-grid-item label="Acknowledged By">{{ requestForMaterials.acknowledgedBy }} on
                        {{ requestForMaterials.acknowledgedOn }}
                    </ui-data-grid-item>
                </ui-data-grid>
                <ui-data-grid class="mt-8"
                              v-if="['Submitted','Acknowledged','Complete','In Progress'].includes(requestForMaterials.status)">
                    <ui-data-grid-item label="Submitted By">{{ requestForMaterials.submittedBy }} on
                        {{ requestForMaterials.submittedOn }}
                    </ui-data-grid-item>
                </ui-data-grid>
                <ui-data-grid class="mt-8">
                    <ui-data-grid-item label="Created By">{{ requestForMaterials.createdBy }} on
                        {{ requestForMaterials.createdOn }}
                    </ui-data-grid-item>
                    <ui-data-grid-item label="Last Updated By" v-if="requestForMaterials.lastUpdatedBy">{{
                            requestForMaterials.lastUpdatedBy
                        }} on {{
                            requestForMaterials.lastUpdatedOn
                        }}
                    </ui-data-grid-item>
                </ui-data-grid>
            </div>
        </template>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import UiContainer from "../../ui/UiContainer.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiHeader from "../../ui/UiHeader.vue";
import UiInput from "../../ui/UiInput.vue";
import UiToggle from "../../ui/UiToggle.vue";
import {ProjectDeliveryRequestForMaterials as RequestForMaterials, ResourcePlanningReport} from "@models";
import moment from "moment";
import RequestForMaterialItem from "./RequestForMaterialItem.vue";
import UiTextarea from "../../ui/UiTextarea.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";

export default {
    components: {
        UiDataGrid,
        UiTextarea,
        RequestForMaterialItem,
        draggable,
        UiToggle, UiInput, UiHeader, UiDataGridItem, UiDatePicker, UiButtonNew, UiContainer
    },
    props: {
        item: Object,
        packageReference: Number,
        packageName: String,
        requestForMaterialsId: '',
    },
    data() {
        return {
            requestForMaterials: {},
            contractRender: 0,
            busy: false,
            dateTimeError: '',
            moment,
            resourcePlanningReport: Object,
            state: 'loading',
        }
    },
    computed: {},
    methods: {
        async acknowledge() {
            await this.requestForMaterials.acknowledge();
            Object.assign(this.item, this.requestForMaterials);
            this.busy = false;
            this.$emit("statusChanged", this.item, this.requestForMaterials);
        },
        async complete() {
            await this.requestForMaterials.complete();
            Object.assign(this.item, this.requestForMaterials);
            this.busy = false;
            this.$emit("statusChanged", this.item, this.requestForMaterials);
        },
        async backTo(status) {
            if (status === 'draft') {
                await this.requestForMaterials.draft();
            } else if (status === 'submitted') {
                await this.requestForMaterials.submit();
            }
            Object.assign(this.item, this.requestForMaterials);
            this.busy = false;
            this.$emit("statusChanged", this.item, this.requestForMaterials);
        }
    },
    async mounted() {
        this.requestForMaterials = await RequestForMaterials.find(this.packageReference, this.requestForMaterialsId);
        this.resourcePlanningReport = await ResourcePlanningReport.find(this.packageReference);
        this.state = 'loaded'
        this.contractRender++;
    },
}
</script>
